module.exports = __webpack_public_path__ + "static/media/中文校对.653e8b0c.png";